import { getUser } from '~src/user';
import Uppy from '@uppy/core';
import Dashboard from '@uppy/dashboard';
import AwsS3 from '@uppy/aws-s3';
import Italian from '@uppy/locales/lib/it_IT';
import ImageEditor from '@uppy/image-editor';
import Webcam from '@uppy/webcam';
const GoldenRetriever = require('@uppy/golden-retriever');

import '@uppy/core/dist/style.css';
import '@uppy/dashboard/dist/style.css';
import '@uppy/image-editor/dist/style.css';
import '@uppy/webcam/dist/style.css';
import { modifyState } from '~src/state';

export const createUploaderInstance = async (params) => {
  if (!params || !params.alias) {
    throw new Error('uploader params not specified');
  }

  const { userToken } = await getUser();

  const uppy = new Uppy({
    debug: false,
    locale: Italian,
    autoProceed: false,
    restrictions: {
      maxFileSize: 20 * 1024 * 1024, // 20 MBs
      maxNumberOfFiles: 10,
      minNumberOfFiles: 1,
      allowedFileTypes: ['image/*'],
    },
  })
    .use(Dashboard, params.pluginDashboard)
    .use(ImageEditor, {
      target: Dashboard,
      quality: 0.8,
    })
    .use(Webcam, {
      target: Dashboard,
      onBeforeSnapshot: () => Promise.resolve(),
      countdown: false,
      modes: ['picture'],
      mirror: true,
      videoConstraints: {
        facingMode: 'user',
        width: { min: 720, ideal: 1280, max: 1920 },
        height: { min: 480, ideal: 800, max: 1080 },
      },
      showRecordingLength: false,
      preferredVideoMimeType: null,
      preferredImageMimeType: null,
      locale: {},
    })
    .use(GoldenRetriever)
    .use(AwsS3, {
      getUploadParameters(file) {
        return fetch(`${process.env.PARSE_SERVER_ENDPOINT}/functions/upload`, {
          method: 'post',
          // Send and receive JSON.
          headers: {
            accept: 'application/json',
            'content-type': 'application/json',
            'x-parse-application-id': process.env.PARSE_APPLICATION_ID,
            'x-parse-session-token': userToken,
          },
          body: JSON.stringify({
            filename: file.name,
            contentType: file.type,
            collection: params.alias,
            bucket: params.bucket || 'default',
            dir: params.dir || '',
          }),
        })
          .then((response) => {
            // Parse the JSON response.
            return response.json();
          })
          .then((data) => {
            // Return an object in the correct shape.
            return {
              method: data.result.method,
              url: data.result.url,
              // Provide content type header required by S3
              headers: {
                'Content-Type': file.type,
              },
            };
          });
      },
    });

  if (params.onComplete) {
    uppy.on('complete', params.onComplete);
  }
  if (params.onError) {
    uppy.on('upload-error', params.onError);
  }

  modifyState(`uploader.${params.alias}`, uppy);

  return uppy;
};
